import update from 'immutability-helper';

import {
  SET_FEED_CONNECTED,
  SET_FEED_TEST_MESSAGE,
  SET_FEED_SOCKET_AUTHENTICATED,
} from './actionTypes';

const initialState = {
  isConnected: false,
  isAuthenticated: false,
  testMessages: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_FEED_CONNECTED: {
      return {
        ...state,
        isConnected: action.payload,
      };
    }
    case SET_FEED_SOCKET_AUTHENTICATED: {
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    }
    case SET_FEED_TEST_MESSAGE: {
      return update(state, {
        testMessages: {
          $push: [action.payload],
        },
      });
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
